<div class="skl-bg-first" [class.skeleton-loading]="!current">
  <ng-container *ngIf="current">
    <a
      [href]="domain + '/' + appService.languageCode + '/casino'"
      (click)="$event.preventDefault()"
      [routerLink]="['/', appService.languageCode, 'casino']"
    >
      <span class="onact96-not">{{ 'casino' | translate }}</span>
    </a>
    <i class="icon-right-arrow"></i>
    <span class="cur">{{ current }}</span>
  </ng-container>
</div>
